module.exports = __webpack_public_path__ + "img/ppe.9a7a1f52.jpg";